import { z } from 'zod';

export interface AddressApi {
  id?: string;
  neighborhoodId: string;
  cityId?: string;
  streetName: string;
  doorNumber: string;
  apartmentNumber?: string;
  corner?: string;
  zipCode?: string;
  lat?: string | number;
  long?: string | number;
  createdAt?: string;
  updatedAt?: string;
}

export const addressSchema = z.object({
  neighborhoodId: z.string().min(1, 'El barrio es requerido'),
  streetName: z.string().min(1, 'El nombre de la calle es requerido'),
  doorNumber: z.string().min(1, 'El número de puerta es requerido'),
  apartmentNumber: z.string().optional(),
  corner: z.string().optional(),
  zipCode: z.string().optional(),
});

export type AddressSchema = z.infer<typeof addressSchema>;

export const defaultAddressValues: AddressSchema = {
  neighborhoodId: '',
  streetName: '',
  doorNumber: '',
  apartmentNumber: '',
  corner: '',
  zipCode: '',
};
